export default {
    CONTACT_ADDED: 'contact-added',
    NEW_MESSAGE: 'new-message',
    UPDATE_MESSAGE: 'update-message',
    USER_ONLINE_STATUS: 'user-online-status',
    USER_IS_TYPING: 'user-is-typing',
}